import React, { useState, useEffect, useCallback } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8002/api/v1';
const token = () => localStorage.getItem('watrly_admin_token') || '';
const api = async (method, path, body) => {
  const r = await fetch(`${API}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || 'خطأ في الاتصال');
  return d;
};

/* ─── SVG Icons ─────────────────────────────────────────────────────────── */
const Icons = {
  ship: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2c1.3 0 1.9.5 2.5 1"/><path d="M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76"/><path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"/></svg>,
  truck: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.684-.948V8a1 1 0 0 1 1-1h1.382a1 1 0 0 1 .894.553l1.448 2.894A1 1 0 0 0 19.382 11H22v6a1 1 0 0 1-1 1h-1"/><circle cx="7" cy="18" r="2"/><circle cx="19" cy="18" r="2"/></svg>,
  user: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 1 0-16 0"/></svg>,
  building: <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M12 6h.01M8 10h.01M16 10h.01M12 10h.01M8 14h.01M16 14h.01M12 14h.01"/></svg>,
  plus: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14m-7-7h14"/></svg>,
  edit: <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>,
  trash: <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  check: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>,
  x: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6 6 18M6 6l12 12"/></svg>,
  search: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>,
  file: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/></svg>,
  text: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>,
  hash: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="4" y1="9" x2="20" y2="9"/><line x1="4" y1="15" x2="20" y2="15"/><line x1="10" y1="3" x2="8" y2="21"/><line x1="16" y1="3" x2="14" y2="21"/></svg>,
  calendar: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  list: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>,
  toggle: <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="5" width="22" height="14" rx="7"/><circle cx="16" cy="12" r="3"/></svg>,
  eye: <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>,
  eyeOff: <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" y1="2" x2="22" y2="22"/></svg>,
  grip: <svg className="w-3.5 h-3.5 text-gray-300" viewBox="0 0 24 24" fill="currentColor"><circle cx="9" cy="5" r="1.5"/><circle cx="15" cy="5" r="1.5"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><circle cx="9" cy="19" r="1.5"/><circle cx="15" cy="19" r="1.5"/></svg>,
  shield: <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  star: <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
};

const TABS = [
  { key: 'ships',    label: 'الأشياب',       icon: Icons.ship,     bg: 'from-sky-500 to-blue-600',    light: 'bg-sky-50 text-sky-700 border-sky-200',   dot: 'bg-sky-500' },
  { key: 'vehicles', label: 'المركبات',       icon: Icons.truck,    bg: 'from-amber-500 to-orange-600', light: 'bg-amber-50 text-amber-700 border-amber-200', dot: 'bg-amber-500' },
  { key: 'drivers',  label: 'السائقين',       icon: Icons.user,     bg: 'from-emerald-500 to-teal-600', light: 'bg-emerald-50 text-emerald-700 border-emerald-200', dot: 'bg-emerald-500' },
  { key: 'tenants',  label: 'شركات المياه',   icon: Icons.building, bg: 'from-violet-500 to-purple-600', light: 'bg-violet-50 text-violet-700 border-violet-200', dot: 'bg-violet-500' },
];

const FIELD_TYPES = [
  { value: 'text',         label: 'نص',            icon: Icons.text },
  { value: 'number',       label: 'رقم',           icon: Icons.hash },
  { value: 'phone',        label: 'هاتف',          icon: Icons.hash },
  { value: 'email',        label: 'بريد',          icon: Icons.text },
  { value: 'textarea',     label: 'نص طويل',       icon: Icons.text },
  { value: 'date',         label: 'تاريخ',         icon: Icons.calendar },
  { value: 'file',         label: 'ملف',           icon: Icons.file },
  { value: 'select',       label: 'قائمة',         icon: Icons.list },
  { value: 'multi_select', label: 'اختيار متعدد',  icon: Icons.list },
  { value: 'url',          label: 'رابط',          icon: Icons.text },
  { value: 'checkbox',     label: 'خانة اختيار',   icon: Icons.toggle },
];

/* ─── Simple Input Component ────────────────────────────────────────────── */
const Input = ({ label, required, children, hint, className = '' }) => (
  <div className={className}>
    {label && <label className="block text-xs font-bold text-gray-500 mb-1.5 tracking-wide">{label} {required && <span className="text-red-400">*</span>}</label>}
    {children}
    {hint && <p className="text-[11px] text-gray-400 mt-1">{hint}</p>}
  </div>
);

const inputCls = "w-full px-3.5 py-2.5 rounded-lg border border-gray-200 bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 transition-all";

/* ─── Add/Edit Modal — simplified 2-step ──────────────────────────────── */
function RequirementModal({ open, onClose, onSave, initial, tab }) {
  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  // Form fields
  const [nameAr, setNameAr] = useState('');
  const [nameEn, setNameEn] = useState('');
  const [fieldKey, setFieldKey] = useState('');
  const [fieldType, setFieldType] = useState('text');
  const [isRequired, setIsRequired] = useState(false);
  const [needsVerify, setNeedsVerify] = useState(false);
  const [groupKey, setGroupKey] = useState('');
  const [groupNameAr, setGroupNameAr] = useState('');
  const [optionsText, setOptionsText] = useState('');
  const [fileTypes, setFileTypes] = useState('');
  const [sortOrder, setSortOrder] = useState(0);

  const isEdit = !!initial?.id;

  useEffect(() => {
    if (!open) return;
    setStep(1); setErr('');
    if (initial) {
      setNameAr(initial.field_name_ar || '');
      setNameEn(initial.field_name_en || '');
      setFieldKey(initial.field_key || '');
      setFieldType(initial.field_type || 'text');
      setIsRequired(!!initial.is_required);
      setNeedsVerify(!!initial.needs_verification);
      setGroupKey(initial.group_key || '');
      setGroupNameAr(initial.group_name_ar || '');
      setOptionsText(initial.options ? (Array.isArray(initial.options) ? initial.options.join('\n') : '') : '');
      setFileTypes(initial.file_types || '');
      setSortOrder(initial.sort_order || 0);
    } else {
      setNameAr(''); setNameEn(''); setFieldKey(''); setFieldType('text');
      setIsRequired(false); setNeedsVerify(false);
      setGroupKey(''); setGroupNameAr(''); setOptionsText(''); setFileTypes(''); setSortOrder(0);
    }
  }, [open, initial]);

  // Auto-generate field_key from Arabic name
  useEffect(() => {
    if (!isEdit && nameEn) {
      setFieldKey(nameEn.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, ''));
    }
  }, [nameEn, isEdit]);

  const goNext = () => {
    if (!nameAr.trim()) { setErr('الاسم العربي مطلوب'); return; }
    if (!fieldKey.trim()) { setErr('المفتاح الإنجليزي مطلوب'); return; }
    setErr(''); setStep(2);
  };

  const save = async () => {
    setSaving(true); setErr('');
    try {
      const options = ['select','multi_select'].includes(fieldType) && optionsText
        ? optionsText.split('\n').map(s => s.trim()).filter(Boolean) : undefined;
      await onSave({
        field_key: fieldKey.trim().replace(/\s+/g, '_').toLowerCase(),
        field_name_ar: nameAr.trim(),
        field_name_en: nameEn.trim() || undefined,
        field_type: fieldType,
        is_required: isRequired,
        needs_verification: needsVerify,
        group_key: groupKey.trim() || undefined,
        group_name_ar: groupNameAr.trim() || undefined,
        file_types: fileTypes.trim() || undefined,
        sort_order: parseInt(sortOrder) || 0,
        options,
      });
      onClose();
    } catch (e) { setErr(e.message); }
    finally { setSaving(false); }
  };

  if (!open) return null;
  const showOptions = ['select','multi_select'].includes(fieldType);
  const showFile = fieldType === 'file';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm" />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden" dir="rtl">
        {/* Header */}
        <div className={`bg-gradient-to-l ${tab.bg} px-6 py-5`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center text-white">{tab.icon}</div>
              <div>
                <h2 className="text-base font-bold text-white">{isEdit ? 'تعديل المتطلب' : 'إضافة متطلب جديد'}</h2>
                <p className="text-white/60 text-xs mt-0.5">{tab.label} — الخطوة {step} من 2</p>
              </div>
            </div>
            <button onClick={onClose} className="w-8 h-8 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">{Icons.x}</button>
          </div>
          {/* Progress bar */}
          <div className="mt-4 h-1 bg-white/20 rounded-full overflow-hidden">
            <div className={`h-full bg-white rounded-full transition-all duration-300 ${step === 1 ? 'w-1/2' : 'w-full'}`} />
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          {err && <div className="mb-4 px-4 py-2.5 bg-red-50 border border-red-100 text-red-600 rounded-lg text-sm">{err}</div>}

          {step === 1 ? (
            <div className="space-y-4">
              <Input label="اسم المتطلب بالعربي" required>
                <input value={nameAr} onChange={e => setNameAr(e.target.value)} className={inputCls} placeholder="مثال: رقم الهوية الوطنية" autoFocus />
              </Input>
              <Input label="الاسم بالإنجليزي" hint="يُستخدم لإنشاء المفتاح تلقائياً">
                <input value={nameEn} onChange={e => setNameEn(e.target.value)} className={inputCls} placeholder="National ID" dir="ltr" />
              </Input>
              <Input label="مفتاح الحقل" required hint="معرّف فريد بالإنجليزي — يتولد تلقائياً">
                <input value={fieldKey} onChange={e => setFieldKey(e.target.value.replace(/\s+/g,'_').toLowerCase())} disabled={isEdit} className={`${inputCls} font-mono ${isEdit ? 'bg-gray-50 text-gray-400' : ''}`} placeholder="national_id" dir="ltr" />
              </Input>
              <Input label="نوع الحقل" required>
                <div className="grid grid-cols-3 gap-2">
                  {FIELD_TYPES.map(t => (
                    <button key={t.value} onClick={() => setFieldType(t.value)}
                      className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm font-medium transition-all ${fieldType === t.value ? 'border-blue-400 bg-blue-50 text-blue-700 ring-2 ring-blue-100' : 'border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50'}`}>
                      <span className="text-gray-400">{t.icon}</span>
                      {t.label}
                    </button>
                  ))}
                </div>
              </Input>
            </div>
          ) : (
            <div className="space-y-4">
              {/* Toggle switches */}
              <div className="flex gap-3">
                <button onClick={() => setIsRequired(!isRequired)}
                  className={`flex-1 flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all ${isRequired ? 'border-red-300 bg-red-50' : 'border-gray-200 bg-white hover:border-gray-300'}`}>
                  <div className={`w-9 h-5 rounded-full relative transition-colors ${isRequired ? 'bg-red-500' : 'bg-gray-300'}`}>
                    <div className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-all ${isRequired ? 'right-0.5' : 'left-0.5'}`} />
                  </div>
                  <div className="text-right">
                    <div className={`text-sm font-bold ${isRequired ? 'text-red-700' : 'text-gray-600'}`}>إلزامي</div>
                    <div className="text-[11px] text-gray-400">يجب تعبئته</div>
                  </div>
                </button>
                <button onClick={() => setNeedsVerify(!needsVerify)}
                  className={`flex-1 flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all ${needsVerify ? 'border-amber-300 bg-amber-50' : 'border-gray-200 bg-white hover:border-gray-300'}`}>
                  <div className={`w-9 h-5 rounded-full relative transition-colors ${needsVerify ? 'bg-amber-500' : 'bg-gray-300'}`}>
                    <div className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow-sm transition-all ${needsVerify ? 'right-0.5' : 'left-0.5'}`} />
                  </div>
                  <div className="text-right">
                    <div className={`text-sm font-bold ${needsVerify ? 'text-amber-700' : 'text-gray-600'}`}>تحقق يدوي</div>
                    <div className="text-[11px] text-gray-400">يراجعه المدير</div>
                  </div>
                </button>
              </div>

              {/* Group */}
              <div className="grid grid-cols-2 gap-3">
                <Input label="مجموعة (مفتاح)">
                  <input value={groupKey} onChange={e => setGroupKey(e.target.value.replace(/\s+/g,'_').toLowerCase())} className={`${inputCls} font-mono`} placeholder="basic_info" dir="ltr" />
                </Input>
                <Input label="اسم المجموعة">
                  <input value={groupNameAr} onChange={e => setGroupNameAr(e.target.value)} className={inputCls} placeholder="المعلومات الأساسية" />
                </Input>
              </div>

              {/* Options for select */}
              {showOptions && (
                <Input label="الخيارات" hint="اكتب كل خيار في سطر">
                  <textarea value={optionsText} onChange={e => setOptionsText(e.target.value)} rows={3} className={`${inputCls} resize-none`} placeholder={"خيار 1\nخيار 2\nخيار 3"} />
                </Input>
              )}

              {/* File types */}
              {showFile && (
                <Input label="أنواع الملفات المسموحة">
                  <input value={fileTypes} onChange={e => setFileTypes(e.target.value)} className={inputCls} placeholder="pdf,jpg,png" dir="ltr" />
                </Input>
              )}

              <Input label="ترتيب العرض">
                <input type="number" value={sortOrder} onChange={e => setSortOrder(e.target.value)} className={`${inputCls} w-24`} dir="ltr" />
              </Input>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex gap-3 px-6 py-4 border-t border-gray-100 bg-gray-50/50">
          {step === 1 ? (
            <>
              <button onClick={goNext} className={`flex-1 py-2.5 rounded-xl font-bold text-white text-sm bg-gradient-to-l ${tab.bg} hover:opacity-90 active:scale-[0.99] transition-all`}>التالي</button>
              <button onClick={onClose} className="px-5 py-2.5 rounded-xl text-gray-500 text-sm font-medium hover:bg-gray-100 transition-colors">إلغاء</button>
            </>
          ) : (
            <>
              <button onClick={save} disabled={saving} className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl font-bold text-white text-sm bg-gradient-to-l ${tab.bg} hover:opacity-90 active:scale-[0.99] transition-all ${saving ? 'opacity-50' : ''}`}>
                {saving ? <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : Icons.check}
                {isEdit ? 'حفظ' : 'إضافة'}
              </button>
              <button onClick={() => setStep(1)} className="px-5 py-2.5 rounded-xl text-gray-500 text-sm font-medium hover:bg-gray-100 transition-colors">رجوع</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─── Requirement Row ──────────────────────────────────────────────────── */
function ReqRow({ req, tab, onEdit, onToggle, onDelete, onDragStart, onDragOver, onDrop, onDragEnd, isDragging, isDragOver }) {
  const typeInfo = FIELD_TYPES.find(t => t.value === req.field_type) || { icon: Icons.text, label: req.field_type };
  const [confirmDel, setConfirmDel] = useState(false);

  return (
    <div
      draggable
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      className={`group flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${isDragging ? 'opacity-40 scale-[0.98] ring-2 ring-blue-300' : ''} ${isDragOver ? 'border-blue-400 bg-blue-50/50 shadow-md' : ''} ${req.is_active ? 'bg-white hover:shadow-md border border-gray-100 hover:border-gray-200' : 'bg-gray-50 border border-dashed border-gray-200 opacity-60'}`}>
      {/* Grip */}
      <div className="flex-shrink-0 cursor-grab opacity-40 group-hover:opacity-100 transition-opacity active:cursor-grabbing">{Icons.grip}</div>

      {/* Type badge */}
      <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${tab.light}`}>
        {typeInfo.icon}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-bold text-gray-900 text-sm truncate">{req.field_name_ar}</span>
          {req.field_name_en && <span className="text-gray-400 text-xs hidden sm:inline" dir="ltr">({req.field_name_en})</span>}
        </div>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="text-[11px] text-gray-400 font-mono" dir="ltr">{req.field_key}</span>
          {req.group_name_ar && (
            <>
              <span className="text-gray-300">·</span>
              <span className="text-[11px] text-gray-400">{req.group_name_ar}</span>
            </>
          )}
        </div>
      </div>

      {/* Badges */}
      <div className="flex items-center gap-1.5 flex-shrink-0">
        {req.is_required && (
          <span className="px-2 py-0.5 rounded-md bg-red-50 text-red-600 text-[11px] font-bold border border-red-100">إلزامي</span>
        )}
        {req.needs_verification && (
          <span className="px-2 py-0.5 rounded-md bg-amber-50 text-amber-600 text-[11px] font-bold border border-amber-100 flex items-center gap-1">{Icons.shield} تحقق</span>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center gap-1 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
        <button onClick={() => onToggle(req.id)} title={req.is_active ? 'تعطيل' : 'تفعيل'}
          className={`w-7 h-7 rounded-lg flex items-center justify-center transition-colors ${req.is_active ? 'hover:bg-gray-100 text-gray-400' : 'hover:bg-emerald-50 text-emerald-500'}`}>
          {req.is_active ? Icons.eyeOff : Icons.eye}
        </button>
        <button onClick={() => onEdit(req)} title="تعديل"
          className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-blue-50 text-gray-400 hover:text-blue-500 transition-colors">
          {Icons.edit}
        </button>
        {!confirmDel ? (
          <button onClick={() => setConfirmDel(true)} title="حذف"
            className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-red-50 text-gray-400 hover:text-red-500 transition-colors">
            {Icons.trash}
          </button>
        ) : (
          <div className="flex items-center gap-1 animate-in fade-in">
            <button onClick={() => { onDelete(req.id); setConfirmDel(false); }}
              className="px-2 py-1 rounded-md bg-red-500 text-white text-[11px] font-bold hover:bg-red-600 transition-colors">تأكيد</button>
            <button onClick={() => setConfirmDel(false)}
              className="px-2 py-1 rounded-md bg-gray-100 text-gray-500 text-[11px] hover:bg-gray-200 transition-colors">لا</button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ─── Tab Content ──────────────────────────────────────────────────────── */
function TabContent({ tab }) {
  const [data, setData] = useState({ requirements: [], groups: [] });
  const [loading, setLoading] = useState(true);
  const [showInactive, setShowInactive] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState('');
  const [toast, setToast] = useState(null);
  const [dragId, setDragId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);

  const showToast = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2500); };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const d = await api('GET', `/admin/requirements/${tab.key}?include_inactive=${showInactive}`);
      setData(d);
    } catch (e) { showToast(e.message, false); }
    finally { setLoading(false); }
  }, [tab.key, showInactive]);

  useEffect(() => { load(); }, [load]);

  const handleSave = async (payload) => {
    if (editing) {
      await api('PUT', `/admin/requirements/${tab.key}/${editing.id}`, payload);
      showToast('تم التحديث');
    } else {
      await api('POST', `/admin/requirements/${tab.key}`, payload);
      showToast('تمت الإضافة');
    }
    load();
  };

  const handleToggle = async (id) => { await api('PATCH', `/admin/requirements/${tab.key}/${id}/toggle`); load(); };
  const handleDelete = async (id) => { await api('DELETE', `/admin/requirements/${tab.key}/${id}`); showToast('تم التعطيل'); load(); };

  const handleDragStart = (id) => setDragId(id);
  const handleDragOver = (e, id) => { e.preventDefault(); setDragOverId(id); };
  const handleDragEnd = () => { setDragId(null); setDragOverId(null); };
  const handleDrop = async (e, dropId) => {
    e.preventDefault();
    if (!dragId || dragId === dropId) { handleDragEnd(); return; }
    const list = [...(data.requirements || [])];
    const fromIdx = list.findIndex(r => r.id === dragId);
    const toIdx = list.findIndex(r => r.id === dropId);
    if (fromIdx < 0 || toIdx < 0) { handleDragEnd(); return; }
    const [moved] = list.splice(fromIdx, 1);
    list.splice(toIdx, 0, moved);
    const reordered = list.map((r, i) => ({ ...r, sort_order: i * 10 }));
    setData(prev => ({ ...prev, requirements: reordered }));
    handleDragEnd();
    try {
      await api('POST', `/admin/requirements/${tab.key}/reorder`, reordered.map((r, i) => ({ id: r.id, sort_order: i * 10 })));
      showToast('تم إعادة الترتيب');
    } catch (e) { showToast(e.message, false); load(); }
  };

  const filtered = (data.requirements || []).filter(r =>
    !search || r.field_name_ar?.includes(search) || r.field_key?.includes(search) || r.field_name_en?.toLowerCase().includes(search.toLowerCase())
  );

  // Group items
  const groups = {};
  for (const r of filtered) {
    const gk = r.group_key || '_ungrouped';
    if (!groups[gk]) groups[gk] = { name: r.group_name_ar || 'عام', items: [] };
    groups[gk].items.push(r);
  }

  return (
    <>
      {/* Toast */}
      {toast && (
        <div className={`fixed top-5 left-1/2 -translate-x-1/2 z-[100] px-5 py-2.5 rounded-xl shadow-lg text-sm font-bold flex items-center gap-2 ${toast.ok ? 'bg-emerald-500 text-white' : 'bg-red-500 text-white'}`}>
          {toast.ok ? Icons.check : Icons.x} {toast.msg}
        </div>
      )}

      {/* Toolbar */}
      <div className="flex items-center gap-3 mb-5 flex-wrap">
        <div className="flex-1 min-w-[200px] relative">
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">{Icons.search}</span>
          <input value={search} onChange={e => setSearch(e.target.value)} className={`${inputCls} pr-10`} placeholder="ابحث..." />
        </div>
        <label className="flex items-center gap-2 text-xs text-gray-500 cursor-pointer select-none">
          <input type="checkbox" checked={showInactive} onChange={e => setShowInactive(e.target.checked)} className="rounded border-gray-300" />
          المعطّلة
        </label>
        <button onClick={() => { setEditing(null); setModalOpen(true); }}
          className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-white text-sm font-bold bg-gradient-to-l ${tab.bg} hover:opacity-90 active:scale-[0.98] transition-all shadow-sm`}>
          {Icons.plus}
          <span>إضافة متطلب</span>
        </button>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex flex-col items-center py-20 text-gray-400 gap-3">
          <span className="w-7 h-7 border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin" />
          <span className="text-sm">جاري التحميل...</span>
        </div>
      ) : filtered.length === 0 ? (
        <div className="flex flex-col items-center py-20 text-gray-400 gap-2">
          <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center text-gray-300 mb-2">{tab.icon}</div>
          <p className="text-sm font-bold text-gray-500">لا توجد متطلبات بعد</p>
          <p className="text-xs text-gray-400">اضغط "إضافة متطلب" للبدء</p>
        </div>
      ) : (
        <div className="space-y-6">
          {Object.entries(groups).map(([gk, g]) => (
            <div key={gk}>
              <div className="flex items-center gap-2 mb-2 px-1">
                <div className={`w-1.5 h-1.5 rounded-full ${tab.dot}`} />
                <span className="text-xs font-bold text-gray-500 tracking-wide">{g.name}</span>
                <span className="text-[11px] text-gray-300">({g.items.length})</span>
              </div>
              <div className="space-y-1.5">
                {g.items.map(req => (
                  <ReqRow key={req.id} req={req} tab={tab}
                    onEdit={r => { setEditing(r); setModalOpen(true); }}
                    onToggle={handleToggle}
                    onDelete={handleDelete}
                    onDragStart={() => handleDragStart(req.id)}
                    onDragOver={(e) => handleDragOver(e, req.id)}
                    onDrop={(e) => handleDrop(e, req.id)}
                    onDragEnd={handleDragEnd}
                    isDragging={dragId === req.id}
                    isDragOver={dragOverId === req.id && dragId !== req.id}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <RequirementModal open={modalOpen} onClose={() => { setModalOpen(false); setEditing(null); }}
        onSave={handleSave} initial={editing} tab={tab} />
    </>
  );
}

/* ─── Main Page ────────────────────────────────────────────────────────── */
export default function RequirementsPage() {
  const [activeTab, setActiveTab] = useState('ships');
  const [stats, setStats] = useState(null);

  useEffect(() => { api('GET', '/admin/requirements/stats/overview').then(setStats).catch(() => {}); }, []);

  const tab = TABS.find(t => t.key === activeTab);

  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto" dir="rtl">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-xl font-black text-gray-900">إدارة المتطلبات</h1>
        <p className="text-gray-400 text-xs mt-1">تحكّم بالحقول والوثائق المطلوبة لكل فئة</p>
      </div>

      {/* Tab bar */}
      <div className="flex gap-1.5 p-1 bg-gray-100 rounded-xl mb-6">
        {TABS.map(t => {
          const active = activeTab === t.key;
          const s = stats?.[t.key];
          return (
            <button key={t.key} onClick={() => setActiveTab(t.key)}
              className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-bold transition-all ${active ? `bg-gradient-to-l ${t.bg} text-white shadow-md` : 'text-gray-500 hover:text-gray-700 hover:bg-white/60'}`}>
              <span className={active ? 'text-white' : 'text-gray-400'}>{t.icon}</span>
              <span className="hidden sm:inline">{t.label}</span>
              {s && <span className={`text-[11px] px-1.5 py-0.5 rounded-full font-bold ${active ? 'bg-white/20' : 'bg-gray-200 text-gray-500'}`}>{s.active}</span>}
            </button>
          );
        })}
      </div>

      {/* Summary cards */}
      {stats?.[activeTab] && (
        <div className="grid grid-cols-3 gap-3 mb-6">
          {[
            { label: 'الإجمالي',  val: stats[activeTab].total,    color: 'text-gray-900' },
            { label: 'نشط',       val: stats[activeTab].active,   color: 'text-emerald-600' },
            { label: 'إلزامي',    val: stats[activeTab].required, color: 'text-red-500' },
          ].map(c => (
            <div key={c.label} className="bg-white rounded-xl border border-gray-100 px-4 py-3 text-center">
              <div className={`text-2xl font-black ${c.color}`}>{c.val}</div>
              <div className="text-[11px] text-gray-400 font-bold mt-0.5">{c.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Tab content */}
      <TabContent key={activeTab} tab={tab} />
    </div>
  );
}
